import { Input, MyTableComponent } from "components"
import { useState, useEffect } from "react"
import { Box } from "theme-ui"
import tittle from "./Tittle.png"
import { IDeviceStatusInformation } from "@types"
import { useFetchActionsCheckDeviceStateQuery } from "../../store/Features/actions/checkDeviceState-api-slice"
import { useTranslation } from "react-i18next"

export const CheckDeviceState = () => {
         // language translator
 const { t } = useTranslation("translation")
 const { data } = useFetchActionsCheckDeviceStateQuery()
 const [selectedData, setSelectedData] = useState<IDeviceStatusInformation[]>([])
 const [allData, setAllData] = useState<IDeviceStatusInformation[]>([])

 const columns = [
  { Header: t("headquarters"), accessor: "status" },
  { Header: t("Attachment"), accessor: "communication" },
  { Header: t("status"), accessor: "device_state" },
  { Header: t("description"), accessor: "status_description" },
  { Header: t("state"), accessor: "interference_state" },
 ]
 useEffect(() => {
  if (data) {
   const statusInformationData = data.map((single) => {
    return single?.device_status_information
   })

   setSelectedData(statusInformationData)
   setAllData(statusInformationData)
  }
  // eslint-disable-next-line
 }, [data])

 const searchHandler = (keyword: string) => {
  if (keyword !== "") {
   const filterData: IDeviceStatusInformation[] = allData?.filter(
    (item) => item?.status?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== -1,
   )
   setSelectedData([...filterData])
  } else {
   setSelectedData(allData)
  }
 }

 return (
  <div className="w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full pt-6">
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold">{t("querySystemStatus")}</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">{t("category")}</p>

      <div className="bg-white h-8 w-12 rounded mx-4  border-light-gray border-[1.5px] flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder={t("search")}
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
   />
  </div>
 )
}
